// Generated by CoffeeScript 1.9.3
var _BlockAppendor;

module.exports = _BlockAppendor = (function() {
  function _BlockAppendor(_config) {
    this._config = _config;
  }

  _BlockAppendor.prototype.render = function(options) {
    return this._render(options);
  };

  return _BlockAppendor;

})();



//////////////////
// WEBPACK FOOTER
// ./node_modules/renderkid/lib/layout/block/blockAppendor/_BlockAppendor.js
// module id = ar5c
// module chunks = 0